import api from './api';

export const authService = {
  login: async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    return response.data;
  },
  getMe: async () => {
    const response = await api.get('/me');
    return response.data;
  },
};

export const categoryService = {
  list: async (type) => {
    const params = type ? { type } : {};
    const response = await api.get('/categories', { params });
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/categories', data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.put(`/categories/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`/categories/${id}`);
    return response.data;
  },
};

export const transactionService = {
  list: async (filters = {}) => {
    const response = await api.get('/transactions', { params: filters });
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/transactions', data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.put(`/transactions/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`/transactions/${id}`);
    return response.data;
  },
  export: async (filters = {}) => {
    const response = await api.get('/transactions/export', {
      params: filters,
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'transacoes.csv');
    document.body.appendChild(link);
    link.click();
    link.remove();
  },
};

export const reportService = {
  summary: async (from, to) => {
    const response = await api.get('/reports/summary', {
      params: { from, to },
    });
    return response.data;
  },
  topDayExpense: async () => {
    const response = await api.get('/reports/top-day-expense');
    return response.data;
  },
  topMonthExpense: async () => {
    const response = await api.get('/reports/top-month-expense');
    return response.data;
  },
  topMonthIncome: async () => {
    const response = await api.get('/reports/top-month-income');
    return response.data;
  },
  expensesByCategory: async (from, to) => {
    const response = await api.get('/reports/expenses-by-category', {
      params: { from, to },
    });
    return response.data;
  },
  cashflow: async (from, to, groupBy = 'day') => {
    const response = await api.get('/reports/cashflow', {
      params: { from, to, group_by: groupBy },
    });
    return response.data;
  },
};

export const accountService = {
  list: async () => {
    const response = await api.get('/accounts');
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/accounts', data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.put(`/accounts/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`/accounts/${id}`);
    return response.data;
  },
};


